import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {sessionsArray,classroomSessionsArray,practicalSessionsArray} from '../../_models/staticArray'

@Component({
  selector: 'app-add-session-modal',
  templateUrl: './add-session-modal.component.html',
  styleUrls: ['./add-session-modal.component.scss']
})
export class AddSessionModalComponent implements OnInit {

  sessions = sessionsArray
  classroomSessions = classroomSessionsArray
  practicalSessions = practicalSessionsArray 
  sessionForm: FormGroup;
  titleList: string[];
  titleDisabled: boolean = true;
  showUnits: boolean = false;
  showUploads = true;
  sessionData: any; //DATA TO EDIT FROM MATERIAL TILE
  loading: boolean;
  displayMsg: any;

  constructor(public _portfolioService: PortfolioService, public _snackbar: MatSnackBar, public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.disableClose = false
  }

  ngOnInit() {
    console.log('this.data', this.data)
    this.sessionData = this.data.data
    if (this.sessionData) {
      let event = {
        value: this.sessionData.sessionType
      }
      this.sessionSelected(event)
      if (this.sessionData.unitNo) {
        this.showUnits = true
      }
    }
    this.createSessionForm()
  }

  createSessionForm() {
    this.sessionForm = new FormGroup({
      sessionType: new FormControl('', Validators.required),
      title: new FormControl('', Validators.required),
      unit: new FormControl('')
    })
  }

  sessionSelected(event) {
    console.log("sessionSelected EVENT", event)
    this.titleDisabled = false
    if (event.value == 'classroom') {
      this.titleList = this.classroomSessions;
    }
    else {
      this.titleList = this.practicalSessions
    }
  }
  titleChanged(event) {
    console.log()
    if (event.value == 'Track Maintenance' || event.value == 'Technical Certificate') {
      this.showUnits = true
      this.sessionForm.get('unit').setValidators(Validators.required);
    }
    else {
      this.showUnits = false
      this.sessionForm.get('unit').clearValidators();
    }
  }

  saveSession() {
    console.log('save Session')
    if (this.sessionForm.valid) {
      if (this.showUnits && this.sessionForm.value.unit) {
        console.log("this.sessionForm.value.unit", this.sessionForm.value.unit);
        this.submitSession()
      }
      else if (!this.showUnits) {
        this.submitSession()
      }
    }
    else {
      this.sessionForm.markAllAsTouched()
      this.loading = false;
    }
  }


  submitSession() {
    this.loading = true
    this.displayMsg = null
    console.log('this.formGroup', this.sessionForm)
    let data = {
      sessionType: this.sessionForm.value.sessionType,
      title: this.sessionForm.value.title,
      unitNo: this.sessionForm.value.unit,
      course: this.data.course._id,
      portfolioId: this.data.course.portfolioId
    }
    console.log('data to be submitted', data)
    if (this.data.isEdit) {
      data['sessionId'] = this.data.data._id
      this._portfolioService.editSession(data).subscribe(res => {
        console.log('edit', res)
        this.dialogRef.close(res)
        this.loading = false
      })
    }
    else {
      this._portfolioService.addSession(data).subscribe(res => {
        console.log('res', res)
        this.dialogRef.close(res)
      }, err => {
        console.log(err.msg)
        this.displayMsg = err.msg
        this.loading = false
        // alert(err)
      })
    }
  }

}
